import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.header',
		defaultMessage: 'Looks like you don’t have issue security configured',
		description:
			'Header for issue security empty state, indicating that issue security is not yet configured.',
	},
	headerIssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.header-issue-term-refresh',
		defaultMessage: 'Looks like you don’t have work item security configured',
		description:
			'Header for issue security empty state, indicating that issue security is not yet configured.',
	},
	headerNotJiraAdmin: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.header-not-jira-admin',
		defaultMessage: 'Contact your admin to set up issue security',
		description:
			'Header for issue security empty state, indicating that issue security is not yet configured when viewing as not a Jira admin.',
	},
	headerNotJiraAdminIssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.header-not-jira-admin-issue-term-refresh',
		defaultMessage: 'Contact your admin to set up work item security',
		description:
			'Header for issue security empty state, indicating that issue security is not yet configured when viewing as not a Jira admin.',
	},
	description: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.description',
		defaultMessage:
			'Control who has the ability to view certain issues by assigning specific people and groups to security levels.',
		description:
			'Description for issue security empty state, indicating security levels must be configured.',
	},
	descriptionIssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.description-issue-term-refresh',
		defaultMessage:
			'Control who has the ability to view certain work items by assigning specific people and groups to security levels.',
		description:
			'Description for issue security empty state, indicating security levels must be configured.',
	},
	readMoreAboutIssueSecurity: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.read-more-about-issue-security',
		defaultMessage: 'Read more about issue security',
		description: 'Link taking user to documentation to read more about issue security.',
	},
	readMoreAboutIssueSecurityIssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.empty-state.read-more-about-issue-security-issue-term-refresh',
		defaultMessage: 'Read more about work item security',
		description: 'Link taking user to documentation to read more about issue security.',
	},
});
